import React from "react";
import "./container.css";

const Container = () => {
  return (
    <div className="thecontainer">
      {/* <div className="SignupTitle">
        <h2>Sign up!</h2>
      </div>
      <div className="SignupDescription">
        <p>
          At CodeTech. We Value Connection And Shared Experiences. Join Our
          Vibrant Community To Enhance Your Daily Interactions With AI, Share
          Stories, Exchange Tips, And Discover New Ways To Maximize Your Ai-Con
          Experience.
        </p>
      </div> */}
      {/* <div className="SignupButton">
        <button>Join Community</button>
      </div> */}
    </div>
  );
};

export default Container;
